module.exports = __webpack_public_path__ + "media/widget/AchievedGoals-2f190bb8.png";